import * as SwitchPrimitive from "@radix-ui/react-switch";
import classNames from "classnames/bind";
import React from "react";
import styles from "./Switch.module.scss";

const cx = classNames.bind(styles);

type SwitchProps = {
  id: string;
  value: boolean;
  defaultChecked?: boolean;
  onChange?: (isChecked: boolean) => void;
  isRequired?: boolean;
  isDisabled?: boolean;
  label: string;
  name: string;
};

/**
 * Allows users to flip between binary options
 */
const Switch = ({
  id,
  value,
  defaultChecked,
  onChange,
  isRequired,
  isDisabled,
  label,
  name,
}: SwitchProps) => {
  return (
    <div className={cx("container")}>
      <SwitchPrimitive.Root
        className={cx("SwitchRoot")}
        id={id}
        required={isRequired}
        disabled={isDisabled}
        checked={value}
        defaultChecked={defaultChecked}
        onCheckedChange={onChange}
        name={name}
      >
        <SwitchPrimitive.Thumb className={cx("SwitchThumb")} />
      </SwitchPrimitive.Root>

      <label htmlFor={name}>{label}</label>
    </div>
  );
};

export default Switch;
